import React from 'react';
import {useDropzone} from 'react-dropzone';
import styled from 'styled-components';
import CloudIcon from '../Icons/CloudIcon';
import ExcelIcon from '../Icons/ExcelIcon';
import TrashIcon from '../Icons/TrashIcon';
import OutlinedBtn from '../OutlinedBtn';
import { HumanFileSize } from '../../utils/helpers';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const getColor = (props) => {
  if (props.isDragAccept) {
      return '#00e676';
  }
  if (props.isDragReject) {
      return '#ff1744';
  }
  if (props.isFocused) {
      return '#2196f3';
  }
  return '#eeeeee';
}

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-width: 2px;
  border-radius: 2px;
  border-color: ${props => getColor(props)};
  border-style: dashed;
  background-color: #fff;
  color: #bdbdbd;
  outline: none;
  transition: border .24s ease-in-out;
`;

export default function StyledDropzone({ files, setFiles, loading }) {
  const {
    acceptedFiles,
    getRootProps,
    getInputProps,
    isFocused,
    isDragAccept,
    isDragReject
  } = useDropzone({
    onDrop: (incomingFiles) => {
      setFiles(incomingFiles);
    },
    accept: {
      'text/html': ['.xlsx', '.xls'],
    },
    maxFiles: 1,
    maxSize: 52428800
  });

  const myFiles = files.map(f => (
    <div className='myFilesWrapper'>
      <div className='myFile'>
        <div className='icon'><ExcelIcon /></div>
        <div>
          <div className='name'>{f.name}</div>
          <div className='size'>{HumanFileSize(f.size)}</div>
        </div>
      </div>
      <a className='removeFile' onClick={()=>setFiles([])}><TrashIcon /></a>
    </div>
  ));

  if (loading)
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <CircularProgress
          variant="indeterminate"
          disableShrink
          sx={(theme) => ({
            color: '#1C1C1C',
            animationDuration: '550ms',
          })}
          size={100}
          thickness={6}
        />
      </Box>
    );

  return (
    <div className="container">
      <Container {...getRootProps({isFocused, isDragAccept, isDragReject})}>
        <input {...getInputProps()} />
        <div className='uploadZoneWrapper'>
          <CloudIcon />
          <div className='uploadZoneTitle'>Choose a file or drag & drop it here</div>
          <div className='uploadZoneSubTitle'>Only EXCEL format, up to 50MB</div>
        </div>
        <OutlinedBtn sx={{ marginTop: "22px"}} title="Browse files" variant="outlined" />
      </Container>
      <aside>
        {myFiles}
      </aside>
    </div>
  );
}

{/* <StyledDropzone /> */}